import { useHistory } from 'react-router-dom';
import { isElectronApp } from '../../../helpers/common';
import OpenDesktopPrompt from '../../../component/openDesktopPrompt';
import { ROUTES } from '../../../routes/urls';

function GoogleRedirect() {
  const history = useHistory();

  return <div>{!isElectronApp() ? <OpenDesktopPrompt onClickOpenHere={() => history.push(ROUTES.INBOX)} /> : null}</div>;
}

export default GoogleRedirect;
